"use client";

import { RandomHomePageImage } from "../RandomHomePageImage/RandomHomePageImage";
import classNames from "classnames/bind";
import styles from "./SupportHubHomeImage.module.css";

const cx = classNames.bind(styles);

export function SupportHubHomeImage({ imageUrls }: { imageUrls: string[] }) {
  /* data-is-fullwidth-homepage is a CSS hook used for the layout.css */
  return (
    <div className={cx("container")} data-is-fullwidth-homepage="true">
      <div className={cx("hero")}>
        <div className={cx("image-container")}>
          <RandomHomePageImage imageUrls={imageUrls} className={cx("image")} />
        </div>
      </div>
    </div>
  );
}
